
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plan-your-trip/[slug]",
      function () {
        return require("private-next-pages/plan-your-trip/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plan-your-trip/[slug]"])
      });
    }
  